import React from "react";
import { Button, Dialog, DialogContent, DialogTitle, DialogActions, Box,Typography } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
const ServerErrorModal = ({serverError,isLLP,  toggleModalFn,handleTabChange}) => {
    return(
        <>
            <Dialog
                open={serverError.modal}
                onClose={toggleModalFn}
                className='server-error-modal'
                maxWidth="md"
            >
                <DialogTitle id="scroll-dialog-title">
                    Verify Amount Error
                </DialogTitle>
                <DialogContent className="error-dialog-content" dividers={true}>
                        {serverError?.data?.errors?.map((err,idx)=>{
                            return( <Box key={idx} display="flex" alignItems="start" mb={1}>
                                <ErrorIcon fontSize="small" color="error" style={{  marginRight: 8 }} />
                                <Typography variant="body2">{err.key}: {err.message}   </Typography>
                              </Box>)
                        })}
                    {isLLP ? <span
                        onClick={() => handleTabChange("", 1)}
                        style={{
                            color: '#007bff',
                            cursor: 'pointer',
                            textDecoration: 'underline',
                            display: 'inline-block',
                            marginLeft: "28px",
                            fontSize: "14px"
                        }}
                    >
                        Manage LLP Amount
                    </span> : null}
                        
                </DialogContent>
                <DialogActions>
                    <Button onClick={toggleModalFn} color='primary' size='small' variant='outlined'>Close</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
export default ServerErrorModal;